import type { WoosMapLocalityDetail, WoosMapLocalityDetailAddressComponent } from "@/modules/woosmap/types"

const getDataFromAddressComponent = (
  type: string,
  addressComponents: WoosMapLocalityDetailAddressComponent[],
  key: "longName" | "shortName"
): string => {
  const foundComponent = addressComponents.find(component => {
    return component.types[0] === type
  })
  return foundComponent ? foundComponent[key] : ""
}

type LocalityLevels = {
  city: string
  country: string
  countryCode: string
  state: string
  subState: string
}

export const getLocalityLevelsByTypes = (result: WoosMapLocalityDetail): LocalityLevels => {
  const { addressComponents } = result

  return {
    city: getDataFromAddressComponent("locality", addressComponents, "longName"),
    country: getDataFromAddressComponent("country", addressComponents, "longName"),
    countryCode: getDataFromAddressComponent("country", addressComponents, "shortName"),
    state: getDataFromAddressComponent("state", addressComponents, "longName"),
    subState: getDataFromAddressComponent("county", addressComponents, "longName"),
  } as LocalityLevels
}
